import { useState, useMemo } from "react";
import moment from "moment";
import { switchString } from "../../utils/utils";
import { Button, Checkbox, Modal } from "src/components";
import InvoiceDropdown from "./invoice-menu.component";
import downArrow from "src/assets/down-arrow.svg";
import { useNavigate } from "react-router-dom";
import InvoiceReject from "../invoice-details/invoice-reject";
import InvoiceReassign from "../invoice-master/InvoiceReassign";
import Contact from "src/assets/Contact.svg";
import { downloadInvoice } from "src/services/invoice-api";
import InvoiceEscalate from "../invoice-master/InvoiceEscalate";
import InvoiceSetPriority from "../invoice-master/InvoiceSetPriority";
import star from "src/features/fields/assets/star.svg";
import starEmpty from "src/assets/starEmpty.svg";
import InvoiceOnHold from "../invoice-master/InvoiceOnHold";
import Download from "src/features/fields/assets/Download copy.svg";
import Reject from "src/features/fields/assets/Reject.svg";
import Escalate from "src/features/fields/assets/Escalate.svg";
import Priority from "src/features/fields/assets/Priority.svg";
import Hold from "src/features/fields/assets/Hold.svg";
import { useToast } from "src/hooks/useToast";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { useDispatch } from "react-redux";
import { invoiceActions } from "src/context/invoice-slice";


const menuItems = [
  { label: "Re-assign Invoice", id: "reassign", icon: Contact },
  { label: "Put On hold", id: "hold", icon: Hold },
  { label: "Reject Invoice", id: "reject", icon: Reject },
  { label: "Download Invoice", id: "download", icon: Download },
  { label: "Download E-Inv Ack", id: "download-ack", icon: Download },
  { label: "Download E-Way Bill", id: "download-eway", icon: Download },
  { label: "Escalate Invoice", id: "escalate", icon: Escalate },
  { label: "Set Priority", id: "setpriority", icon: Priority },
  { label: "Remove Priority", id: "removepriority", icon: Priority },
];

interface InvoiceDetailCardProps {
  status: string;
  data: any;
  checkDataType: boolean;
  viewDetails?: boolean;
  isExpandable?: boolean;
  isExpandedInitial?: boolean;
  isEntry?: boolean;
  index?: number;
  invoiceData?: any;
  handleAddItem?: any;
  approvalScreen?: boolean;
  fetchApprovalData?: () => Promise<void>;
  hasViewDetailsPermission:boolean;
  detailsPermissionLoading:boolean;
  hasPermissionReassign:boolean;
  reassignPermissionLoading:boolean;
  hasPermissionPutOnHold:boolean;
  putOnHoldPermissionLoading:boolean;
  hasPermissionReject:boolean;
  rejectPermissionLoading:boolean;
  hasPermissionEscalate:boolean;
  escalatePermissionLoading:boolean;
  hasPermissionSetPriority:boolean;
  setPriorityPermissionLoading:boolean;
}

const InvoiceApprovalDetailCard = ({
  data,
  checkDataType = true,
  status,
  viewDetails = true,
  isExpandable = true,
  isExpandedInitial = false,
  index,
  invoiceData,
  approvalScreen = false,
  hasViewDetailsPermission,
  detailsPermissionLoading,
  hasPermissionReassign,
  reassignPermissionLoading,
  hasPermissionPutOnHold,
  putOnHoldPermissionLoading,
  hasPermissionReject,
  rejectPermissionLoading,
  hasPermissionEscalate,
  escalatePermissionLoading,
  hasPermissionSetPriority,
  setPriorityPermissionLoading,
  fetchApprovalData,
}: InvoiceDetailCardProps) => {
  const [isExpanded, setIsExpanded] = useState(isExpandedInitial || index === 0);
  const naviagate = useNavigate();
  const [modalStates, setModalStates] = useState({
    reject: false,
    reassign: false,
    hold: false,
    escalate: false,
    setpriority: false,
    removepriority: false,
  });
  const { selectedInvoices } = useSelector((state: RootState) => state.invoice);
  const invoiceKey = invoiceData?.stockist_invoice_attachment_id;
  const isSelected = selectedInvoices.some((invoice: any) => invoice.key === invoiceKey && invoice.fuid_no === invoiceData?.fuid_no);
  const dispatch = useDispatch();
  const { InvoiceApprovalFilters } = useSelector((state: RootState) => state.invoice);
  const company_code = InvoiceApprovalFilters?.company?.map((item) => item.code)?.join(",");

  const { toast } = useToast();

 

  const isLoadingPermissions =
    reassignPermissionLoading || putOnHoldPermissionLoading || rejectPermissionLoading || escalatePermissionLoading || setPriorityPermissionLoading;

  const permissionMap: Record<string, boolean> = {
    reassign: hasPermissionReassign,
    hold: hasPermissionPutOnHold,
    reject: hasPermissionReject,
    escalate: hasPermissionEscalate,
    setpriority: hasPermissionSetPriority,
    removepriority: hasPermissionSetPriority,
  };

  const filteredMenuItems = useMemo(() => {
    if (isLoadingPermissions || !invoiceData) return [];

    return menuItems.filter((item) => {
      if (permissionMap.hasOwnProperty(item.id) && !permissionMap[item.id]) {
        return false;
      }
      if (!invoiceData?.is_eway_applicable && item.id === "download-eway") {
        return false;
      }
      if (invoiceData?.is_prioritised && item.id === "setpriority") {
        return false;
      }
      if (!invoiceData?.is_prioritised && item.id === "removepriority") {
        return false;
      }
      if (invoiceData?.fileStatusHdr?.fuid_status_id === 8 && item.id === "reject") {
        return false;
      }
      if (invoiceData?.fileStatusHdr?.fuid_status_id === 8 && item.id === "reassign") {
        return false;
      }
      if (invoiceData?.fileStatusHdr?.fuid_status_id === 8 && item.id === "hold") {
        return false;
      }
      if (invoiceData?.fileStatusHdr?.fuid_status_id === 8 && item.id === "escalate") {
        return false;
      }
      return true;
    });
  }, [
    invoiceData,
    isLoadingPermissions,
    hasPermissionReassign,
    hasPermissionPutOnHold,
    hasPermissionReject,
    hasPermissionEscalate,
    hasPermissionSetPriority,
  ]);

  const verifyStringType = function (input: string) {
    const date = new Date(input);
    const numberRegex = /^\d+$/;
    if (!isNaN(date.getTime()) && input.trim() !== "" && !numberRegex.test(input)) {
      return moment(input).format("DD MMM, YYYY");
    } else {
      return input;
    }
  };

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleCloseModal = (modalName: string) => {
    setModalStates((prev: any) => ({ ...prev, [modalName]: false }));
  };

  const handleOptionClick = (item: any) => {
    switch (item.id) {
      case "reject":
        setModalStates((prev: any) => ({ ...prev, reject: true }));
        break;
      case "hold":
        setModalStates((prev: any) => ({ ...prev, hold: true }));
        break;
      case "reassign":
        setModalStates((prev: any) => ({ ...prev, reassign: true }));
        break;
      case "download":
        if (!invoiceData?.file_path) {
          toast({ description: "Invoice not found", variant: "destructive" });
          return;
        }
        downloadInvoice(invoiceData?.file_path, company_code as string).then((res: any) => {
          if (res?.data?.success && res?.data?.data) {
            window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
          } else {
            console.error("Failed to download the invoice.");
          }
        });
        break;
      case "download-ack":
        if (!invoiceData?.einv_attachment_path) {
          toast({ description: "E-Invoice not found", variant: "destructive" });
          return;
        }
        downloadInvoice(invoiceData?.einv_attachment_path, company_code as string).then((res: any) => {
          if (res?.data?.success && res?.data?.data) {
            window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
          } else {
            console.error("Failed to download the E-Invoice.");
          }
        });
        break;
      case "download-eway":
        if (invoiceData?.eway_attachment_path == null || invoiceData?.eway_attachment_path == "") {
          toast({ description: "E-Way Bill not found", variant: "destructive" });
          return;
        }
        downloadInvoice(invoiceData?.eway_attachment_path, company_code as string).then((res: any) => {
          if (res?.data?.success && res?.data?.data) {
            window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
          } else {
            console.error("Failed to download the E-Way Bill.");
          }
        });
        break;
      default:
        break;
    }
  };

  return (
    <div className="mb-4">
      <div className="hidden">
        <Modal isOpen={modalStates.reject} isHeader={false} onCloseModal={() => handleCloseModal("reject")} title="Reject Invoice">
          <InvoiceReject
            company_code={InvoiceApprovalFilters?.company}
            division_code={InvoiceApprovalFilters?.division}
            startDate={InvoiceApprovalFilters?.dateRange?.from}
            endDate={InvoiceApprovalFilters?.dateRange?.to}
            assignee_id={InvoiceApprovalFilters?.assignee}
            city={InvoiceApprovalFilters?.city}
            district={InvoiceApprovalFilters?.district}
            state={InvoiceApprovalFilters?.state}
            ordering={InvoiceApprovalFilters?.sorting}
            status={InvoiceApprovalFilters?.status}
            tab={"approval"}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("reject");
              fetchApprovalData?.();
            }}
          />
        </Modal>
        <Modal isOpen={modalStates.reassign} isHeader={false} onCloseModal={() => handleCloseModal("reassign")} title="Reassign Invoice">
          <InvoiceReassign
            company_code={InvoiceApprovalFilters?.company}
            division_code={InvoiceApprovalFilters?.division}
            startDate={InvoiceApprovalFilters?.dateRange?.from}
            endDate={InvoiceApprovalFilters?.dateRange?.to}
            assignee_id={InvoiceApprovalFilters?.assignee}
            city={InvoiceApprovalFilters?.city}
            district={InvoiceApprovalFilters?.district}
            state={InvoiceApprovalFilters?.state}
            ordering={InvoiceApprovalFilters?.sorting}
            status={InvoiceApprovalFilters?.status}
            tab={"approval"}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("reassign");
              fetchApprovalData?.();
            }}
          />
        </Modal>
        <Modal isOpen={modalStates.escalate} isHeader={false} onCloseModal={() => handleCloseModal("escalate")} title="Escalate Invoice">
          <InvoiceEscalate
            company_code={InvoiceApprovalFilters?.company}
            division_code={InvoiceApprovalFilters?.division}
            startDate={InvoiceApprovalFilters?.dateRange?.from}
            endDate={InvoiceApprovalFilters?.dateRange?.to}
            assignee_id={InvoiceApprovalFilters?.assignee}
            city={InvoiceApprovalFilters?.city}
            district={InvoiceApprovalFilters?.district}
            state={InvoiceApprovalFilters?.state}
            ordering={InvoiceApprovalFilters?.sorting}
            status={InvoiceApprovalFilters?.status}
            tab={"approval"}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("escalate");
              fetchApprovalData?.();
            }}
          />
        </Modal>
        <Modal isOpen={modalStates.setpriority} isHeader={false} onCloseModal={() => handleCloseModal("setpriority")} title="Set Priority">
          <InvoiceSetPriority
            company_code={InvoiceApprovalFilters?.company}
            division_code={InvoiceApprovalFilters?.division}
            startDate={InvoiceApprovalFilters?.dateRange?.from}
            endDate={InvoiceApprovalFilters?.dateRange?.to}
            assignee_id={InvoiceApprovalFilters?.assignee}
            city={InvoiceApprovalFilters?.city}
            district={InvoiceApprovalFilters?.district}
            state={InvoiceApprovalFilters?.state}
            ordering={InvoiceApprovalFilters?.sorting}
            status={InvoiceApprovalFilters?.status}
            tab={"approval"}
            unset={false}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("setpriority");
              fetchApprovalData?.();
            }}
          />
        </Modal>
        <Modal isOpen={modalStates.removepriority} isHeader={false} onCloseModal={() => handleCloseModal("removepriority")} title="Remove Priority">
          <InvoiceSetPriority
            company_code={InvoiceApprovalFilters?.company}
            division_code={InvoiceApprovalFilters?.division}
            startDate={InvoiceApprovalFilters?.dateRange?.from}
            endDate={InvoiceApprovalFilters?.dateRange?.to}
            assignee_id={InvoiceApprovalFilters?.assignee}
            city={InvoiceApprovalFilters?.city}
            district={InvoiceApprovalFilters?.district}
            state={InvoiceApprovalFilters?.state}
            ordering={InvoiceApprovalFilters?.sorting}
            status={InvoiceApprovalFilters?.status}
            tab={"approval"}
            unset={true}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("removepriority");
              fetchApprovalData?.();
            }}
          />
        </Modal>
        <Modal isOpen={modalStates.hold} isHeader={false} onCloseModal={() => handleCloseModal("hold")} title="Put on hold">
          <InvoiceOnHold
            company_code={InvoiceApprovalFilters?.company}
            division_code={InvoiceApprovalFilters?.division}
            startDate={InvoiceApprovalFilters?.dateRange?.from}
            endDate={InvoiceApprovalFilters?.dateRange?.to}
            assignee_id={InvoiceApprovalFilters?.assignee}
            city={InvoiceApprovalFilters?.city}
            district={InvoiceApprovalFilters?.district}
            state={InvoiceApprovalFilters?.state}
            ordering={InvoiceApprovalFilters?.sorting}
            status={InvoiceApprovalFilters?.status}
            tab={"approval"}
            invoiceData={invoiceData}
            onCloseModal={() => {
              handleCloseModal("hold");
              fetchApprovalData?.();
            }}
          />
        </Modal>
      </div>

      <header className={"flex justify-between w-full px-5 py-3"}>
        <div className="flex items-center gap-x-2">
          {isExpanded && <div className="w-1.5 h-1.5 bg-red-500 rounded-full mr-4"></div>}
          {invoiceData?.fileStatusHdr?.fuid_status_id === 1 && (
            <Checkbox
              checked={isSelected}
              onChange={() =>
                dispatch(
                  invoiceActions.toggleSelectedInvoice({
                    key: invoiceKey,
                    fuid_no: invoiceData?.fuid_no,
                    invoice_assignment_id: invoiceData?.InvoiceAssignment?.invoice_assignment_id,
                  })
                )
              }
              className="mt-4 ml-4"
            />
          )}
          {invoiceData?.is_prioritised && <img src={star} className="p-1 mr-2 w-8 h-8 rounded-lg border border-[#d0d0d0] shadow-md" alt="star" />}
          {!invoiceData?.is_prioritised && (
            <img src={starEmpty} className="p-1 mr-2 w-8 h-8 rounded-lg border border-[#d0d0d0] shadow-md" alt="star" />
          )}
          {invoiceData?.fileStatusHdr?.fuid_status_id === 6 || invoiceData?.fileStatusHdr?.fuid_status_id === 8 ? (
            <h1 className={"font-semibold text-[1.2rem] mr-4"}>
              <span className="text-gray-400 text-[1.2rem]">Invoice#</span> {invoiceData?.invoice?.invoice_number}
            </h1>
          ) : (
            <h1 className={"font-semibold text-[1.2rem] mr-4"}>
              <span className="text-gray-400 text-[1.2rem]">FUID#</span> {invoiceData?.fuid_no}
            </h1>
          )}
          <h1
            className={`font-semibold  flex items-center text-xs h-6 px-2 rounded-full`}
            style={{ backgroundColor: invoiceData?.fileStatusHdr?.color_code?.trim(), color: invoiceData?.fileStatusHdr?.text_color_code?.trim() }}
          >
            {status}
            <img className="w-3 h-3 ml-1" src={downArrow} alt="down-arrow" />
          </h1>
          <p className="ml-4 text-[#8051FF] text-sm font-semibold border border-gray-400 rounded-full px-2">{invoiceData?.company_name}</p>
        </div>

        <div className="flex items-center gap-x-2">
          {viewDetails && !detailsPermissionLoading && hasViewDetailsPermission && (
            <Button
              className="h-10 text-white bg-[#8051FF] shadow-sm"
              onClick={() => {
                if (invoiceData?.fileStatusHdr?.fuid_status_id === 1) {
                  toast({
                    description: "Yet To Processed can be viewed in the entry screen",
                    variant: "destructive",
                  });
                  return;
                }
                dispatch(invoiceActions.setCurrentApprovalInvoiceIndex(index || 0));
               //M10-9862
                if (approvalScreen) {
                  naviagate(`/transactions/invoice/${invoiceData?.stockist_invoice_attachment_id}/${1}`,
                    {
                      state: {
                        CompanyCode: invoiceData?.company_code,
                      }
                    }
                  );

                } else {
                  naviagate(`/transactions/invoice/${invoiceData?.stockist_invoice_attachment_id}/${0}`,
                    {
                      state: {
                        CompanyCode: invoiceData?.company_code,
                      }
                    }
                  );
                }//M10-9862
              }}
            >
              View Details
            </Button>
          )}
          {
            <div className="w-10 h-10 text-white shadow-sm">
              <InvoiceDropdown
                placeholder="..."
                menuItems={filteredMenuItems}
                displayKey="label"
                onOptionClick={handleOptionClick}
                currentSelected={undefined}
                setModalStates={setModalStates}
              />
            </div>
          }
          {isExpandable && (
            <Button className="w-10 h-10 bg-[#F1F1F1] border border-1-black" onClick={handleToggle}>
              <img className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
            </Button>
          )}
        </div>
      </header>
      <div className="flex items-center gap-x-2 ml-4">
        <img className="w-6 h-6 ml-1" src={Contact} alt="person-img" />
        <span className="text-[#49484C] text-sm">Assigned to</span>
        <div className="w-8 h-8 bg-[#8051FF] flex items-center justify-center text-[#fff] rounded-full">
          {invoiceData?.InvoiceAssignment?.user_name?.slice(0, 2)}
        </div>
        <span className="text-[#49484C] text-sm">{invoiceData?.InvoiceAssignment?.user_name}</span>
      </div>
      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${isExpanded ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"}`}
        style={{ transitionProperty: "max-height, opacity" }}
      >
        <div className={"grid grid-cols-1 w-[80%] gap-x-10 px-5 py-3 mt-5 xl:grid-cols-2 gap-y-5"}>
          {!!data &&
            Object.keys(data)?.length > 0 &&
            Object.entries(data)?.map(
              ([key, value]) =>
                typeof value === "string" &&
                value !== "" && (
                  <div key={key?.toString()} className={"grid grid-cols-2 -space-x-10 -space-y-1 text-sm xl:grid-cols-2"}>
                    <p className="text-[#49484C] place-self-center mr-auto whitespace-break-spaces text-sm leading-[0.02rem] font-normal not-italic">
                      {switchString(key)} :
                    </p>
                    <div className="mr-auto">
                      {checkDataType && <p className="text-[#1B1A1F] mr-auto">{typeof value === "string" ? verifyStringType(value) : ""}</p>}
                      {!checkDataType && <p className="text-[#1B1A1F] mr-auto">{value}</p>}
                    </div>
                  </div>
                )
            )}
        </div>
      </div>
    </div>
  );
};

export default InvoiceApprovalDetailCard;
